import React from "react";
import { useFetchPageByIdOrSlug} from "../../features/page/pageApi";
import PageTitle from "../Title/Responsive/PageTitle/PageTitle";

type Props = {
    slug: string;
};

const PageContent = ({ slug }: Props) => {
    const { data: page } = useFetchPageByIdOrSlug(slug, `page.${slug}`);

    if (!page) {
        return (<></>)
    }

    return (
        <><PageTitle title={page.name}/>
            <section className="py-2 slide-left">
                <div className="container anim-delay-medium">
                    <div className="row slide-left">
                        <div className="col-md-12">
                            <h1 className="text-white mb-2 text-uppercase">{page.name}</h1>
                        </div>
                    </div>
                    <div className="row justify-content-center slide-left">
                        <div className="col-md-12">
                            <div className="card bg-secondary">
                                <div className="card-body p-2 text-white">
                                    <div dangerouslySetInnerHTML={{__html: page.content}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default PageContent;
